import { TranslationObject } from '../../../i18n/translation';

const namespace = 'studiestedsection';
const translations: TranslationObject = {
  cancel: {
    id: `${namespace}.cancel`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  addSted: {
    id: `${namespace}.addSted`,
    nb: 'Legg til studiested',
    en: 'Add faculty/institution',
  },
  editSted: {
    id: `${namespace}.editSted`,
    nb: 'Endre valgt studiested',
    en: 'Edit chosen faculty/institution',
  },
  removeSted: {
    id: `${namespace}.removeSted`,
    nb: 'Fjern valgt studiested',
    en: 'Remove chose faculty/institution',
  },
  showSted: {
    id: `${namespace}.showSted`,
    nb: 'Vis studiested',
    en: 'Show faculty/institution',
  },
  institusjonHeader: {
    id: `${namespace}.institusjonHeader`,
    nb: 'Institusjon',
    en: 'Institution',
  },
  avdelingHeader: {
    id: `${namespace}.avdelingHeader`,
    nb: 'Avdeling',
    en: 'Department',
  },
  signatarHeader: {
    id: `${namespace}.signatarHeader`,
    nb: 'Signatar',
    en: 'Signatory',
  },
  modalTitle: {
    id: `${namespace}.modalTitle`,
    nb: 'Velg studiestedets plassering for samarbeidsavtalen',
    en: 'Chose which places to include in the agreement',
  },
  modalSubtitle: {
    id: `${namespace}.modalSubtitle`,
    nb: 'Plasser samarbeidsavtalen på riktig nivå. Undernivåer kan velges spesifikt.',
    en: 'Find the correct level and place the agreement. Sub-levels may be chosen specifically.',
  },
  modalSubtitleView: {
    id: `${namespace}.modalSubtitleView`,
    nb: 'Informasjon om avtalens studiested og dets plassering. Undernivåer kan være valgt spesifikt.',
    en: "Information regarding the institution and it's placement. Sub-levels may be chosen specifically.",
  },
  modalStedField: {
    id: `${namespace}.modalStedField`,
    nb: 'Velg øverste nivå for studiestedet som skal omfattes av avtalen',
    en: 'Choose the top node in the institution hierarchy', // TODO Noen må finne ut av hva disse greiene skal hete på engelsk
  },
  modalStedFieldView: {
    id: `${namespace}.modalStedFieldView`,
    nb: 'Øverste nivå for studiestedet som omfattes av avtalen',
    en: 'The top node in the institution hierarchy', // TODO Noen må finne ut av hva disse greiene skal hete på engelsk
  },
  modalStedFieldPlaceholder: {
    id: `${namespace}.modalStedFieldPlaceholder`,
    nb: 'Søk etter studiested, og/eller velg fra menyen under.',
    en: 'Search for the top node and/or find it in the menu below.', // TODO Noen må finne ut av hva disse greiene skal hete på engelsk
  },
  modalStedHeader: {
    id: `${namespace}.modalStedHeader`,
    nb: 'Studiested',
    en: 'Department/Faculty',
  },
  modalStatusHeader: {
    id: `${namespace}.modalStatusHeader`,
    nb: 'Status',
    en: 'Status',
  },
  modalHandlingHeader: {
    id: `${namespace}.modalHandlingHeader`,
    nb: 'Handling',
    en: 'Action',
  },
  modalNotOmfattetSteder: {
    id: `${namespace}.modalNotOmfattetSteder`,
    nb: 'Ingen spesifikke studiesteder er huket av. Det betyr at det øverste, valgte nivået, samt alle studiestedene under, er med i avtalen. Fremtidige endringer i hierarkiet, under valgt nivå, vil automatisk inkluderes i avtalen.',
    en: "No faculties have been ticked, which means that the agreement includes the chosen top level and all faculties. Future changes in the hierarchy below the agreement's top level will automatically be included.",
  },
  modalOmfattetSteder: {
    id: `${namespace}.modalOmfattetSteder`,
    nb: 'Spesifikke studiesteder er huket av. Dette betyr at kun det øverste, valgte studiestedet, samt studiestedene som er huket av, inkluderes som spesifikke punkter i avtalen. Mellomnivåer og eventuelle undernivåer av spesifikke punkter i hierarkiet inkluderes også i avtalen, men ikke som egne, spesifikke studiesteder.',
    en: 'Specific faculties have been ticked, which means that the agreement only includes these given places, as well as the top level, as specific faculties in the agreement. Middle levels and potential child nodes of specific points are also included in the agreement, but not as specific faculties.',
  },
  signeringTitle: {
    id: `${namespace}.signeringTitle`,
    nb: 'Signering',
    en: 'Signing',
  },
  signeringSubtitle: {
    id: `${namespace}.signeringSubtitle`,
    nb: 'Søk opp personen som har ansvaret for å signere avtalen for studiestedet. Signeringen foregår ved hjelp av postens signeringsløsning.',
    en: 'Select the person responsible for signing the agreement. The signing process is done through Posten Norge.',
  },
  ansvarligLabel: {
    id: `${namespace}.ansvarligLabel`,
    nb: 'Ansvarlig signatar for studiestedet',
    en: 'Responsible party', // TODO Finn riktig oversettelse
  },
  epostLabel: {
    id: `${namespace}.epostLabel`,
    nb: 'Epostadresse',
    en: 'E-mail address',
  },
  tlfLabel: {
    id: `${namespace}.tlfLabel`,
    nb: 'Telefonnummer',
    en: 'Phone number',
  },
  ansvarligPlaceholder: {
    id: `${namespace}.ansvarligPlaceholder`,
    nb: 'Ansvarlig signatar for studiestedet',
    en: 'Responsible signatory', // TODO Finn riktig oversettelse
  },
  lockedInputPlaceholder: {
    id: `${namespace}.lockedInputPlaceholder`,
    nb: '(Hentes automatisk når signatar er valgt)',
    en: '(Fetched automatically when signatory is selected)',
  },
  // RowStatus labels
  // TODO Fill in correct translations, when support for "omfattet studiested" is implemented and terms are decided upon
  AKTIV_BESTILLINGSPUNKT: {
    id: `${namespace}.AKTIV_BESTILLINGSPUNKT`,
    nb: 'AKTIV_BESTILLINGSPUNKT',
    en: 'AKTIV_BESTILLINGSPUNKT',
  },
  AKTIV_IKKE_BESTILLINGSPUNKT: {
    id: `${namespace}.AKTIV_IKKE_BESTILLINGSPUNKT`,
    nb: 'Aktiv',
    en: 'Active',
  },
  UGYLDIG_BESTILLINGSPUNKTER_I_HIERARKI: {
    id: `${namespace}.UGYLDIG_BESTILLINGSPUNKTER_I_HIERARKI`,
    nb: 'UGYLDIG_BESTILLINGSPUNKTER_I_HIERARKI',
    en: 'UGYLDIG_BESTILLINGSPUNKTER_I_HIERARKI',
  },
  INAKTIV_IKKE_MED_I_AVTALE: {
    id: `${namespace}.INAKTIV_IKKE_MED_I_AVTALE`,
    nb: 'Er ikke inkludert i avtalen',
    en: 'Is not included in the agreement',
  },
};

export default translations;
